// src/components/EventCompanyCard.js
import React from 'react';
import { Link } from 'react-router-dom';
import './EventCompanyCard.css';

const EventCompanyCard = ({ company }) => {
  const {
    id,
    name,
    description,
    logo,
    coverImage,
    location,
    specialties,
    verified,
  } = company;

  return (
    <div className="event-company-card">
      <Link to={`/companies/${id}`} className="company-card-link">
        {/* Image de couverture */}
        <div className="company-cover">
          {coverImage && (
            <img 
              src={coverImage} 
              alt={`Couverture ${name}`}
              className="company-cover-image"
            />
          )}
          {verified && (
            <div className="verified-badge">
              <span className="verified-icon">✓</span>
              Vérifié
            </div>
          )}
        </div>

        {/* Contenu de la carte */}
        <div className="company-card-content">
          {/* Header avec logo et nom */}
          <div className="company-header">
            {logo && (
              <img 
                src={logo} 
                alt={`Logo ${name}`}
                className="company-logo"
              />
            )}
            <div className="company-title">
              <h3 className="company-name">{name}</h3>
              {location && (
                <p className="company-location">{location}</p>
              )}
            </div>
          </div>

          {/* Description */}
          {description && (
            <p className="company-description">
              {description.length > 120 
                ? `${description.substring(0, 120)}...` 
                : description
              }
            </p>
          )}

          {/* Spécialités */}
          {specialties && specialties.length > 0 && (
            <div className="company-specialties">
              {specialties.slice(0, 3).map((specialty, index) => (
                <span key={index} className="specialty-tag">
                  {specialty}
                </span>
              ))}
              {specialties.length > 3 && (
                <span className="specialty-tag more">
                  +{specialties.length - 3}
                </span>
              )}
            </div>
          )}

          {/* Call to action */}
          <div className="company-cta">
            <button className="view-profile-btn">
              Voir le profil
            </button>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default EventCompanyCard;